module.exports = __webpack_public_path__ + "img/ticket_status04.7e8a0f49.png";